import * as React from 'react';
import {
    DirectionalHint, mergeStyleSets, TooltipHost,
    getId, TooltipDelay
} from '@fluentui/react';

const classNames = mergeStyleSets({
    plainCard: {
        padding: 10,
        width: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    textField: {
        paddingRight: 200
    }
});

type TooltipProps = {
    element: JSX.Element;
    text?: string;
    displayElement?: JSX.Element;
}

export function MyTooltip({ element, text, displayElement }: TooltipProps) {
    const hostId: string = getId('tooltipHost');

    return <>
        <TooltipHost
            tooltipProps={{
                onRenderContent: () => {
                    return <>
                        <div>{text}</div>
                        {displayElement && displayElement}
                    </>;
                }
            }}
            delay={TooltipDelay.zero}
            id={hostId}
            directionalHint={DirectionalHint.bottomCenter}
            styles={{ root: { display: 'inline-block' } }}

        >
            {element}
        </TooltipHost>
    </>;
}